// 客户管理路由

const clientRouter = {
  path: 'client',
  name: 'client',
  component: { render: h => h('router-view') },
  meta: { title: 'a' },
  children: [
    {
      path: 'client-center',
      name: 'client-center',
      meta: {
        title: '客户管理中心',
      },
      component: () =>
        import(
          /* webpackChunkName: 'client-center' */ 'views/client/client-center'
        ),
    },
    {
      path: 'client-center/detail/trend/:id',
      name: 'trend',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'trend' */ 'views/client/client-center/detail/trend/index'
        ),
    },
    {
      path: 'client-center/detail/overview/:id',
      name: 'overview',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'overview' */ 'views/client/client-center/detail/overview/index'
        ),
    },
    {
      path: 'client-center/detail/message/:id/',
      name: 'message',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'message' */ 'views/client/client-center/detail/message/index'
        ),
    },
    {
      path: 'client-center/detail/mechanism/:id/',
      name: 'mechanism',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'mechanism' */ 'views/client/client-center/detail/mechanism/index'
        ),
    },
    {
      path: 'client-center/detail/mechanism/:id/add',
      name: 'mechanism-report-add',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'mechanism' */ 'views/client/client-center/detail/mechanism/add/add'
        ),
    },
    {
      path: 'client-center/detail/mechanism/:id/detail',
      name: 'mechanism-report-detail',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'mechanism' */ 'views/client/client-center/detail/mechanism/detail/detail'
        ),
    },
    {
      path: 'client-center/detail/credits/:id',
      name: 'credits',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'credits' */ 'views/client/client-center/detail/credits'
        ),
    },
    // 保险Insurance
    {
      path: 'client-center/detail/Insurance/:id',
      name: 'Insurance',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'Insurance' */ 'views/client/client-center/detail/Insurance'
        ),
    },
    {
      path: 'client-center/detail/guarantee/:id',
      name: 'guarantee',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'guarantee' */ 'views/client/client-center/detail/guarantee'
        ),
    },
    {
      path: 'client-center/detail/application-data/:id',
      name: 'application-data',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'applicationData' */ 'views/client/client-center/detail/application-data'
        ),
    },
    {
      path: 'client-center/detail/annex/:id',
      name: 'annex',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'annex' */ 'views/client/client-center/detail/annex'
        ),
    },
    {
      path: 'client-center/detail/credit-rating/:id',
      name: 'credit-rating',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'credit-rating' */ 'views/client/client-center/detail/credit-rating'
        ),
    },
    {
      path: 'client-center/detail/score-card/:id',
      name: 'client-center-score-card',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'client-center-detail' */ 'views/client/client-center/detail/score-card/index'
        ),
    },
    {
      path: 'client-center/detail/score-card/:id/add',
      name: 'client-center-score-card-add',
      meta: {
        title: '客户管理中心-详情-评分卡-新增记录',
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'client-center-detail' */ 'views/client/client-center/detail/score-card/add-record'
        ),
    },
    {
      path: 'client-center/detail/score-card/:id/detail/:recordId',
      name: 'client-center-score-card-detail',
      meta: {
        title: '客户管理中心-详情-企业评分卡',
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'client-center-detail' */ 'views/client/client-center/detail/score-card/detail'
        ),
    },
    {
      path: 'client-center/center/financial-report/:id',
      name: 'financial-report',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'client-center-detail' */ 'views/client/client-center/detail/financial-report/index'
        ),
    },
    {
      path: 'client-center/center/financing-data/:id',
      name: 'financing-data',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'client-center-detail' */ 'views/client/client-center/detail/financing-data'
        ),
    },
    {
      path: 'client-center/center/lengj-data/:id',
      name: 'lengj-data',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'client-center-detail' */ 'views/client/client-center/detail/lengj-data'
        ),
    },
    {
      path: 'client-center/detail/kpi-data/:id',
      name: 'kpi-data',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
        needCompnyCode: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'client-center-detail' */ 'views/client/client-center/detail/kpi-data'
        ),
    },
    {
      path: 'client-center/detail/financial-analysis/:id',
      name: 'financial-analysis',
      meta: {
        title: '客户管理中心-详情',
        extraCenter: true,
      },
      component: () =>
        import(
          /* webpackChunkName: 'client-center-detail' */ 'views/client/client-center/detail/financial-analysis'
        ),
    },
    {
      path: 'customer-data-export',
      name: 'customer-data-export',
      component: () =>
        import(
          /* webpackChunkName: 'client' */ 'views/client/customer-data-export'
        ),
    },
    {
      path: 'add-customer',
      name: 'add-customer',
      meta: {
        title: '新增企业',
      },
      component: () =>
        import(
          /* webpackChunkName: 'add-customer' */ 'views/client/client-center/add-customer'
        ),
    },
    {
      path: 'batch-calc',
      name: 'batch-calc',
      component: () =>
        import(/* webpackChunkName: 'client' */ 'views/client/batch-calc'),
    },
    {
      path: 'customer-data',
      name: 'customer-data',
      component: () =>
        import(/* webpackChunkName: 'client' */ 'views/client/customer-data'),
    },
    {
      path: 'risk-customer',
      name: 'risk-customer',
      component: () =>
        import(/* webpackChunkName: 'client' */ 'views/client/risk-customer'),
    },
    {
      path: 'blacklist',
      name: 'blacklist',
      component: () =>
        import(/* webpackChunkName: 'client' */ 'views/client/blacklist'),
    },
    {
      path: 'blacklist-details/:id/:backType',
      name: 'blacklist-details',
      meta: { title: '黑名单管理-详情' },
      component: () =>
        import(
          /* webpackChunkName: 'client' */ 'views/client/blacklist/pages/blacklist-details'
        ),
    },
  ],
}

export default clientRouter
